import template from './template.html'

angular.module('contabilidad.polizas')
  .component('contabilidadPolizasFacturascanceladas', {
    bindings: {
      fechaInicio: '<',
      fechaFin: '<',
      idEmpresa: '<',
    },
    template,
    controller: Controller,
  })
Controller.$inject = ['ContabilidadPolizas', '$moment', '$location']

function Controller (ContabilidadPolizas, $moment, $location) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.buscar = buscar

  function $onInit () {
    $ctrl.opciones = {
      fecha_inicio: $ctrl.fechaInicio || $moment().subtract(1, 'months').toDate(),
      fecha_fin: $ctrl.fechaFin || new Date(),
      idEmpresa: $ctrl.idEmpresa || null,
    }
    $ctrl.$promise = ContabilidadPolizas.obtenerOperadoras().then(function (data) {
      $ctrl.operadoras = data
    })
  }

  function buscar () {
    $location.search({
      fechaInicio: $ctrl.opciones.fecha_inicio.toYMD(),
      fechaFin: $ctrl.opciones.fecha_fin.toYMD(),
      idEmpresa: $ctrl.opciones.idEmpresa,
    })
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/facturascanceladas/component.js